import { render, staticRenderFns } from "./LeadGoose.vue?vue&type=template&id=c11ae3be&scoped=true&"
import script from "./LeadGoose.vue?vue&type=script&lang=js&"
export * from "./LeadGoose.vue?vue&type=script&lang=js&"
import style0 from "./LeadGoose.vue?vue&type=style&index=0&id=c11ae3be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11ae3be",
  null
  
)

export default component.exports